import { colors } from "../../Styles";

export function Corner({rotate = 0, size = "25px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg style={{transform: `rotate(${rotate}deg)`}} height={size} width={size} stroke={fillColor} version="1.1" viewBox="0 0 100 100" >
        <path d="M 4 40 A 40 40 0 0 1 40 4 M 40 4 L 95 4 M 4 40 L 4 95" style={{fill: "transparent", strokeWidth: "8px", strokeLinecap: "round"}}/>
    </svg>
  );
}
// 